<template>
    <div>
        <loading v-if="!documents" />
        <div v-else>
            <div v-if="documents.length > 0" class="list-group">
                <a v-for="document in documents"
                   v-bind:key="document.fileName"
                   class="list-group-item list-group-item-action"
                   target="_blank"
                   :href="`${$http.defaults.baseURL}/documentation/file/${document.fileName}`">
                    {{ document.fileName }}
                </a>
            </div>
            <div v-if="documents.length == 0" class="alert alert-secondary">
                <span v-if="typeName">There is currently no {{ typeName.toLowerCase()}} documentation</span>
                <span v-else>There is currently no documentation</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            tag: String,
            partNumberId: Number,
            udn: String,
            typeName: String,
        },
        data() {
            return {
                documents: null
            };
        },
        methods: {},
        watch: {
            async tag(tag) {
                this.documents = null;
                this.documents = (await this.$http.get("/documentation/tag/" + this.tag)).data;
            },
            async partNumberId(newValue, oldValue) {
                this.documents = null;
                this.documents = (await this.$http.get("/documentation/part-number/" + this.partNumberId)).data;
            }, 
            async udnPrefix(newValue, oldValue) {
                this.documents = null;
                this.documents = (await this.$http.get("/documentation/udn/" + this.udnPrefix)).data;
            },
        },
        async created() {
            if (this.tag) {
                this.documents = (await this.$http.get("/documentation/tag/" + this.tag)).data;
            } else if (this.partNumberId) {
                this.documents = (await this.$http.get("/documentation/part-number/" + this.partNumberId)).data;
            } else if (this.udn) {
                this.documents = (await this.$http.get("/documentation/udn/" + this.udn)).data;
            } else {
                this.documents = [];
            }
        }
    };
</script>

<style>
</style>
